export const getRecipeOnDemandMaterialsEndpoint = '/api/v1/recipe-on-demand/materials';
export const getRecipeOnDemandRecipesEndpoint = '/api/v1/recipe-on-demand/recipes';
export const getRecipeOnDemandRecipeEndpoint = '/api/v1/recipe-on-demand/recipes/{recipeId}';
export const getRecipeOnDemandRecipeProfileEndpoint = '/api/v1/recipe-on-demand/recipes/{recipeId}/profile';
export const getRecipeOnDemandRecipeProcessEndpoint = '/api/v1/recipe-on-demand/recipes/{recipeId}/process';
export const getRecipeOnDemandHardnessReferencesEndpoint = '/api/v1/recipe-on-demand/hardness-references';
